import React, { useEffect } from "react";

import "../assets/js/main.min.js";
import { useNavigate } from "react-router-dom";
import "../assets/css/main.min.css";
import "../assets/css/custom.css";
import "react-datepicker/dist/react-datepicker.css";

import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../store/admin/action.js";
import male from "../assets/images/male.png";
import { disableHost, getUser } from "../store/user/action.js";
import CoinSeller from "../component/dialog/CoinSeller.js";
import { OPEN_COIN_SELLER_DIALOGUE } from "../store/seller/seller.type.js";
import AgencyRedeemCreate from "../component/dialog/AgencyRedeemCreate.js";
import { permissionError } from "../util/Alert.js";
import rCoin from "../assets/images/shell.png";
import withdrawImg from "../assets/images/withdraw.png";
import dashBg from "../assets/images/dash-bg.png";
import percentage from "../assets/images/percentage.png";
import multiuser from "../assets/images/multiuser.png";
import coins from "../assets/images/coins.png";
import cardIcon from "../assets/images/icard.svg";
import phoneIcon from "../assets/images/mobile.svg";
import { getSetting } from "../store/redeem/action.js";
import useTranslation from "../hooks/useTranslation";
import LanguageSwitcher from "../languageSwitcher/LanguageSwitcher";
import { T, pageHeader, headerTitle, headerDesc, glassCard } from "../util/theme";

const Admin = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const admin = useSelector((state) => state.admin.seller);
  const { user } = useSelector((state) => state.user);
  const { setting } = useSelector((state) => state.redeem);
  const agencyId = localStorage.getItem("agencyId");

  useEffect(() => {
    dispatch(getProfile(agencyId));
    dispatch(getUser(agencyId));
    dispatch(getSetting());
  }, [dispatch, agencyId]);

  const handleOpenCreator = () => {
    if (admin?.isActive === false) return permissionError();
    dispatch({ type: OPEN_COIN_SELLER_DIALOGUE });
  };
  const handleOpenHostHistory = (id) =>
    navigate("/agencypanel/hosthistory", { state: id });
  const handleClick = (u) => dispatch(disableHost(u));

  const fmt = (v) => Number(v ?? 0).toLocaleString("en-IN");
  const createdAt = admin?.createdAt ? new Date(admin.createdAt) : null;

  return (
    <>
      <div
        className="page-container"
        style={{
          background: "transparent",
          minHeight: "100vh",
          color: T.text,
          paddingBottom: 16,
          fontFamily: T.font,
        }}
      >
        <div className="page" style={{ background: "transparent" }}>
          <div style={{ maxWidth: 480, margin: "0 auto", width: "100%" }}>
            {/* Header — scrolls away with page (LanguageSwitcher too) */}
            <div
              style={{
                ...pageHeader,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 12,
              }}
            >
              <div style={{ minWidth: 0, flex: 1 }}>
                <div style={headerTitle}>{t("dashboard")}</div>
                <div style={headerDesc}>{t("welcome_dashboard")}</div>
              </div>
              <LanguageSwitcher embedded />
            </div>

            {/* Agency Profile Banner — match design: #8F11E3 + watermark */}
            <div
              style={{
                margin: "8px 16px 14px",
                borderRadius: 16,
                background: "linear-gradient(83.1deg, #FD297E -65.66%, #6B01FF 109.32%)",
                padding: "16px 14px",
                boxShadow: "0 8px 24px rgba(107, 1, 255, 0.35)",
                overflow: "hidden",
                position: "relative",
              }}
            >
              {/* Subtle gift watermark (design pattern) */}
              <img
                src={dashBg}
                alt=""
                style={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  bottom: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "bottom center",
                  pointerEvents: "none",
                  zIndex: 0,
                }}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <img
                  src={admin?.image || male}
                  alt=""
                  onError={(e) => {
                    e.target.src = male;
                  }}
                  style={{
                    width: 58,
                    height: 58,
                    borderRadius: "50%",
                    objectFit: "cover",
                    flexShrink: 0,
                    background: "#E5E7EB",
                  }}
                />

                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      fontWeight: 700,
                      fontSize: 16,
                      color: "#FFFFFF",
                      marginBottom: 4,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {admin?.name || t("agency")}
                  </div>
                  {admin?.agencyCode && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "nowrap",
                        gap: 5,
                        fontSize: 12,
                        fontWeight: 400,
                        color: "#FFFFFFA3",
                        marginBottom: 6,
                        whiteSpace: "nowrap",
                        lineHeight: 1,
                      }}
                    >
                      <img
                        src={cardIcon}
                        alt=""
                        width={14}
                        height={11}
                        style={{
                          flexShrink: 0,
                          display: "block",
                          objectFit: "contain",
                        }}
                      />
                      <span>AG-{admin.agencyCode}</span>
                    </div>
                  )}
                  {admin?.mobile && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "nowrap",
                        gap: 5,
                        fontSize: 12,
                        fontWeight: 400,
                        color: "#FFFFFFA3",
                        whiteSpace: "nowrap",
                        lineHeight: 1,
                      }}
                    >
                      <img
                        src={phoneIcon}
                        alt=""
                        width={14}
                        height={14}
                        style={{
                          flexShrink: 0,
                          display: "block",
                          objectFit: "contain",
                        }}
                      />
                      <span>{admin.mobile}</span>
                    </div>
                  )}
                </div>

                <button
                  type="button"
                  className="agency-white-pill"
                  onClick={handleOpenCreator}
                  style={{
                    flexShrink: 0,
                    fontSize: 14,
                    fontWeight: 600,
                    lineHeight: 1,
                    padding: "10px 14px",
                    borderRadius: 10,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4,
                    whiteSpace: "nowrap",
                    background: "#FFFFFF",
                    color: "#8F11E3",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#8F11E3"
                    strokeWidth="2.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                  {t("add_host")}
                </button>
              </div>
            </div>

            {/* 2×3 Stats Grid */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 10,
                padding: "0 16px",
              }}
            >
              <StatTile
                label={(t("current_commission") || "").replace(/Current\s*/i, "").trim() || "Commission"}
                value={`${setting?.agencyCommission || 0}%`}
                icon={<img src={percentage} alt="" width={24} height={24} style={{ objectFit: "contain" }} />}
              />
              <StatTile
                label={(t("current_host_coins") || "").replace(/Current\s*/i, "").trim() || "Host Coin"}
                value={fmt(admin?.currentHostCoin)}
                icon={<img src={rCoin} alt="" width={24} height={24} style={{ objectFit: "contain" }} />}
              />
              <StatTile
                label={t("withdrawn_coins")}
                value={`${admin?.totalWithdrawnCoin || 0} Coins`}
                icon={<img src={withdrawImg} alt="" width={24} height={24} style={{ objectFit: "contain" }} />}
              />
              <StatTile
                label={t("total_hosts")}
                value={fmt(admin?.totalAgencyWiseHost)}
                icon={<img src={multiuser} alt="" width={24} height={24} style={{ objectFit: "contain" }} />}
                onMore={() => navigate("/agencypanel/creators")}
              />
              <StatTile
                label={t("current_coins")}
                value={fmt(admin?.rCoin)}
                icon={<img src={rCoin} alt="" width={24} height={24} style={{ objectFit: "contain" }} />}
              />
              <StatTile
                label={t("total_coins")}
                value={fmt(admin?.currentCoin)}
                icon={<img src={rCoin} alt="" width={24} height={24} style={{ objectFit: "contain" }} />}
              />
            </div>

            {/* About + Created */}
            <div style={{ padding: "16px 16px 8px" }}>
              <p
                style={{
                  margin: 0,
                  lineHeight: 1.55,
                  fontWeight: 400,
                  fontSize: 14,
                  color: "#FFFFFFA1",
                }}
              >
                {/* {admin?.about ||
                  "We help creators grow with data-driven insights and creative direction."} */}
                  {admin?.about || t("agency_about_description")}
              </p>
              <p
                style={{
                  margin: "8px 0 0",
                  fontWeight: 400,
                  fontSize: 14,
                  color: "#FFFFFF",
                }}
              >
                {t("created")}:{" "}
                {createdAt
                  ? createdAt.toLocaleDateString("en-GB").replace(/\//g, "/")
                  : "-"}
              </p>
            </div>

            {/* Full-width metric rows */}
            <SummaryCard
              icon={<img src={multiuser} alt="" width={24} height={24} style={{ objectFit: "contain" }} />}
              title={t("total_hosts")}
              value={fmt(user?.length)}
              onMore={() => navigate("/agencypanel/creators")}
            />
            <SummaryCard
              icon={<TrendGlyph />}
              title={t("current_coins")}
              value={fmt(admin?.rCoin)}
              onMore={() => navigate("/agencypanel/creators")}
            />
            <SummaryCard
              icon={<img src={coins} alt="" width={24} height={24} style={{ objectFit: "contain" }} />}
              title={t("total_coins")}
              value={fmt(admin?.currentCoin)}
              onMore={() => navigate("/agencypanel/hosthistory")}
            />

            {/* Host Details */}
            <div style={{ padding: "8px 16px 8px" }}>
              <div
                style={{
                  fontWeight: 500,
                  fontSize: 16,
                  lineHeight: 1,
                  color: "#FFFFFF",
                  margin: "10px 0 12px",
                }}
              >
                {t("host_details")}
              </div>

              {(user || []).slice(0, 2).map((u) => (
                <HostItem
                  key={u?._id}
                  u={u}
                  onToggle={() => handleClick(u)}
                  onHistory={() => handleOpenHostHistory(u?._id)}
                />
              ))}

              {(user || []).length > 2 && (
                <div
                  style={{
                    marginTop: 10,
                    textAlign: "center",
                    cursor: "pointer",
                    color: "#E0D4FF",
                    fontWeight: 600,
                    fontSize: 14,
                    textDecoration: "underline",
                  }}
                  onClick={() => navigate("/agencypanel/creators")}
                >
                  {t("see_more")}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <CoinSeller />
      <AgencyRedeemCreate />
    </>
  );
};

const StatTile = ({ label, value, icon, onMore }) => (
  <div
    onClick={onMore}
    style={{
      ...glassCard,
      padding: "0px 10px",
      display: "flex",
      alignItems: "center",
      gap: 10,
      cursor: onMore ? "pointer" : "default",
      minHeight: 68,
      background: "#FFFFFF14",
      minWidth: 0,
    }}
  >
    <div
      style={{
        width: 42,
        height: 42,
        borderRadius: 12,
        background: T.iconBox,
        display: "grid",
        placeItems: "center",
        flexShrink: 0,
      }}
    >
      {icon}
    </div>
    <div style={{ minWidth: 0, flex: 1 }}>
      <div
        style={{
          fontWeight: 400,
          fontSize: 14,
          color: T.sub,
          marginBottom: 3,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: 16,
          fontWeight: 800,
          color: "#fff",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {value}
      </div>
    </div>
  </div>
);

const HostItem = ({ u, onToggle, onHistory }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        background:"#FFFFFF14",
        border: "1px solid #FFFFFF1C",
        borderRadius: "16px",
        padding: "14px 14px",
        marginBottom: 12,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <img
          src={u?.image || male}
          alt=""
          style={{
            width: 44,
            height: 44,
            borderRadius: "50%",
            objectFit: "cover",
            flexShrink: 0,
          }}
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div
              style={{
                fontWeight: 700,
                fontSize: 14,
                color: "#fff",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {u?.name || "-"}
            </div>
            <span
              style={{
                background: T.gradPinkPurple,
                color: "#fff",
                fontSize: 10,
                borderRadius: 6,
                padding: "2px 8px",
                fontWeight: 600,
                flexShrink: 0,
              }}
            >
              {t("host")}
            </span>
          </div>
          <div style={{ color: T.sub, fontWeight: 500, fontSize: 12, marginTop: 3 }}>
            {t("ID")}: {u?.uniqueId || "-"}
          </div>
        </div>

        {/* <label className="agency-toggle">
          <input type="checkbox" checked={!!u?.isBlock} onChange={onToggle} />
          <span className="agency-toggle-track" />
        </label> */}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: 14,
          gap: 10,
        }}
      >
        <div
          style={{
            color: "#fff",
            fontWeight: 600,
            fontSize: 13,
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          {t("host_income")}:
          <img src={rCoin} alt="" height={18} width={20} />
          <span style={{ fontWeight: 700 }}>{u?.currentCoin ?? 0}</span>
        </div>

        <button
          type="button"
          className="agency-grad-btn agency-font-bd"
          onClick={onHistory}
          style={{
            padding: "8px 18px",
            fontSize: 12,
            fontWeight: 600,
            borderRadius: 10,
            whiteSpace: "nowrap",
            // boxShadow: "0 4px 14px rgba(255,45,143,0.35)",
          }}
        >
          {t("history")} &gt;&gt;
        </button>
      </div>
    </div>
  );
};

const SummaryCard = ({ icon, title, value, onMore }) => (
  <div
    onClick={onMore}
    style={{
      margin: "0 16px 10px",
      ...glassCard,
      padding: "10px 12px 10px 10px",
      cursor: "pointer",
    }}
  >
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <div
        style={{
          width: 46,
          height: 46,
          borderRadius: 14,
          background: T.iconBox,
          display: "grid",
          placeItems: "center",
          color: "#fff",
        }}
      >
        {icon}
      </div>
      <div style={{ fontWeight: 700, fontSize: 16, color: "#fff", flex: 1 }}>
        {title}
      </div>
      <div
        style={{
          fontWeight: 700,
          fontSize: 20,
          color: "#FFFFFF",
          letterSpacing: 0.3,
        }}
      >
        {value}
      </div>
    </div>
  </div>
);

const PhoneIcon = ({ color }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 18 18"
    fill="none"
    style={{ flexShrink: 0, display: "block" }}
  >
    <path
      d="M11.4176 11.1795L11.0764 11.5192C11.0764 11.5192 10.2641 12.327 8.04789 10.1227C5.83164 7.91924 6.64389 7.11224 6.64389 7.11224L6.85839 6.89774C7.38864 6.37124 7.43889 5.52524 6.97614 4.90724L6.03114 3.64498C5.45814 2.87998 4.35189 2.77873 3.69564 3.43123L2.51814 4.60124C2.19339 4.92524 1.97589 5.34374 2.00214 5.80874C2.06964 6.99899 2.60814 9.55874 5.61114 12.5452C8.79639 15.7117 11.7851 15.8377 13.0069 15.7237C13.3939 15.6877 13.7299 15.4912 14.0006 15.2212L15.0656 14.1622C15.7856 13.4467 15.5831 12.2212 14.6621 11.721L13.2296 10.9417C12.6251 10.6132 11.8901 10.71 11.4176 11.1795Z"
      fill={color}
    />
  </svg>
);

const PercentIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="5" x2="5" y2="19" />
    <circle cx="6.5" cy="6.5" r="2.5" />
    <circle cx="17.5" cy="17.5" r="2.5" />
  </svg>
);

const HostGlyph = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const TrendGlyph = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
    <polyline points="17 6 23 6 23 12" />
  </svg>
);

const CoinsGlyph = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <ellipse cx="12" cy="6" rx="8" ry="3" />
    <path d="M4 6v6c0 1.7 3.6 3 8 3s8-1.3 8-3V6" />
    <path d="M4 12v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" />
  </svg>
);

export default Admin;
